import React from 'react';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  return (
    <div className="relative bg-gradient-to-r from-primary/5 to-secondary/5 py-20 lg:py-32">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-6xl md:text-7xl font-bold mb-4 bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
          Speed Meets Excellence: Unlimited Design and Development
          </h2>
          <h1 className="text-6xl lg:text-5xl font-bold mb-8 text-gray-900">
          – Built Fast, Built Right.
          </h1>
          <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto">
          Get Apps and Designs On-Demand. Pay Monthly, Launch Faster.
          </p>
          <Link to="/signup" className="inline-block bg-primary hover:bg-primary/90 text-white px-8 py-4 rounded-full font-semibold transition-all">
            Get Started Now
          </Link>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white to-transparent"></div>
    </div>
  );
};

export default Hero; 